import { all, call, put, takeLatest } from 'redux-saga/effects';
import { countryListSuccess, countryListFailure } from './actions';
import { COUNTRY_LIST } from './actionTypes';
import apiJunction from '../../utils/api';
import { version } from '../../config';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

function* countryList() {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `/provsvc/${version}/intl/roaming/countries/`,
        });
        yield put(
            countryListSuccess({
                countryList: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            countryListFailure({
                error: e.message,
            }),
        );
    }
}

function* InternationalServiceSage() {
    yield all([takeLatest(COUNTRY_LIST, countryList)]);
}

export default InternationalServiceSage;
